import React from "react";
import { Redirect } from "react-router-dom";

// Authentication related pages

import Login from "../pages/Authentication/Login";


// Dashboard
import Dashboard from "../pages/Dashboard/Dashboard";
import Dashboard2 from "../pages/Dashboard/Dashboard2";

//Administration
import UserList from "../pages/Administration/Users/UserList";
import UserAdd from "../pages/Administration/Users/UserAdd";
import UserAddPublic from "../pages/Administration/Users/UserAddPublic";
import UserEdit from "../pages/Administration/Users/UserEdit";
import UserPermissions from "../pages/Administration/Users/UserPermissions";

import AgentAssign from "../pages/Roles/AgentAssign";
import RolUpdate from "../pages/Roles/RolUpdate";
import RolCreate from "../pages/Roles/RolCreate";

import PermissionAssign from "../pages/Roles/PermissionAssign";

//Contacts
import Contact from "../pages/Contacts/Contact";
import ContactsCreate from "../pages/Contacts/ContactAdd";
import ContactProfile from "../pages/Contacts/ContactProfile";
import Calendario from "../pages/Calendar/Calendario";
import PreContactAdd from "../pages/Contacts/PreContactAdd";
import GrupoTecnicoCreate from "../pages/GrupoTecnicos/GrupoTecnicoCreate";
import GrupoTecnicoUpdate from "../pages/GrupoTecnicos/GrupoTecnicoUpdate";
//Account
import Account from "../pages/Account/Account";
import AccountCreate from "../pages/Account/AccountCreate";
import AccountUpdate from "../pages/Account/AccountUpdate";
// Campaigns
import Campaign from "../pages/Campaign/Campaign";
import CampaignCreate from "../pages/Campaign/CampaignCreate";
import CampaignUpdate from "../pages/Campaign/CampaignUpdate";

//Lengs
import Lengs from "../pages/Lengs/Lengs";
import LengsCreate from "../pages/Lengs/LengsCreate";
import LengsUpdate from "../pages/Lengs/LengsUpdate";


//Error
import  Error404  from "../pages/Error/Error404"

// Rutas Publicas
import Prueba from "../pages/Public/Prueba"


//Casos 

import Casos from "../pages/Casos/Casos";
import CasosAdd from "../pages/Casos/CasosAdd";
import CasosEdit from "../pages/Casos/CasosEdit";
import CasosDetalles from "../pages/Casos/CasosDetalles";
// import CasosPublic from "../pages/Casos/CasosPublic";

//Informes
import Informe from "../pages/Informes/Informe"
import InformesAdd from "../pages/Informes/InformesAdd";
import InformeVer from "../pages/Informes/InformeVer";


//Leads
import Leads from "../pages/Leads/Leads";
import LeadsDetail from "../pages/Leads/LeadsDetail";


//Compras
import Compras from '../pages/Compras/Compras'
import ComprasAdd from '../pages/Compras/ComprasAdd'


const publicRoutes = [
  { path: "/prueba", component: Prueba },

];

const allRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/dashboard2", component: Dashboard2 },
  { path: "/users", component: UserList },
  { path: "/users/add_user", component: UserAdd },
  { path: "/users/:id/edit_user", component: UserEdit },
  { path: "/users/permission_assign/:id", component: UserPermissions },
  { path: "/rol/permission_assign/:id", component: PermissionAssign },
  { path: "/rol/add_rol", component: RolCreate },
  { path: "/rol/agent_assign", component: AgentAssign },
  // { path: "/rol/update_rol", component: RolUpdate },
  { path: "/rol/update_rol/:id", component: RolUpdate },

  { path: "/contact/add_contact", component: ContactsCreate },
  

  { path: "/contact/add_pre_contact", component: PreContactAdd },
  { path: "/contact/add_grupoTecnico", component: GrupoTecnicoCreate },
  { path: "/contact/update_grupoTecnico", component: GrupoTecnicoUpdate },
  { path: "/contacts", component: Contact },
  { path: "/contact/:id/contact_profile", component: ContactProfile },
  { path: "/account", component: Account },
  { path: "/account/create", component: AccountCreate },
  { path: "/account/update/:id", component: AccountUpdate },
  { path: "/campaign", component: Campaign },
  { path: "/campaign/create", component: CampaignCreate },
  { path: "/campaign/update/:id", component: CampaignUpdate },
  { path: "/lengs", component: Lengs },
  { path: "/lengs/create", component: LengsCreate },
  { path: "/lengs/update/:id", component: LengsUpdate },

  { path: "/casos", component: Casos },
  { path: "/casosadd", component: CasosAdd },
  { path: "/casos/:id/edit_caso", component: CasosEdit },
  { path: "/casos/:id/CasosDetalles", component: CasosDetalles },


  { path: "/Informes/:id/", component: Informe},
  { path: "/Informes/:id/add_informe", component: InformesAdd },
  { path: "/informes/:id/ver_informe", component: InformeVer },

  
  { path: "/leads", component: Leads },
  { path: "/leads/:id/leads_detail", component: LeadsDetail },

  { path: "/compras", component: Compras },
  { path: "/compras/add_compras", component: ComprasAdd },

  

  { path: "/calendar/", component: Calendario },
  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "*",  component: Error404 },
];

const authRoutes = [
  { path: "/login", component: Login },
  { path: "/users/add_user2", component: UserAddPublic },
  // { path: "/add/caso", component: CasosPublic },
];





export { publicRoutes, allRoutes, authRoutes };
